import MonitoringChart from "../modal/MonitoringChart";
import { ReactComponent as WaterPressureIcon } from "../images/water-pressure.svg";
import { ReactComponent as WaterLevelIcon } from "../images/water-level.svg";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import HearingIcon from "@mui/icons-material/Hearing";
import WaterIcon from "@mui/icons-material/Water";
import ScienceIcon from "@mui/icons-material/Science";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import { lazyChart } from "../modal/lazyWithRetry";

export const MeasurementType = {
  Flow: 'FLOW',
  Pressure: 'PRESSURE',
  Temperature: 'TEMPERATURE',
  Noise: 'NOISE',
  Level: 'LEVEL',
  Chlorine: 'CHLORINE'
};

export const PeriodType = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR'
};

export const NIGHT_FLOW_DAYS = 90;

export const MEASUREMENT_CONFIGS = {
  flow: {
    id: 'flow',
    tempLabel: "Mjerenje Protoka",
    label: 'Dijagram Protoka',
    unit: 'l/s',
    icon: WaterIcon,
    color: '#21538f',
    // null until real thresholds exist: fake ones draw Min/Max and stretch the y-axis
    lowAlarm: null,
    highAlarm: null,
    chartComponent: MonitoringChart,
    enumType: MeasurementType.Flow,
    exportName: 'Dijagram-Protoka',
    diagramId: 'flow-diagram',
    disabled: false,
  },
  pressure: {
    id: 'pressure',
    tempLabel: "Mjerenje Pritiska",
    label: 'Dijagram Pritiska',
    unit: 'bar',
    icon: WaterPressureIcon,
    color: '#FF6B35',
    lowAlarm: null,
    highAlarm: null,
    chartComponent: MonitoringChart,
    enumType: MeasurementType.Pressure,
    exportName: 'Dijagram-Pritiska',
    diagramId: 'pressure-diagram',
    disabled: false,
  },
  temperature: {
    id: 'temperature',
    tempLabel: "Mjerenje Temperature",
    label: 'Dijagram Temperature',
    unit: '°C',
    icon: ThermostatIcon,
    color: '#E63946',
    lowAlarm: null,
    highAlarm: null,
    chartComponent: MonitoringChart,
    enumType: MeasurementType.Temperature,
    exportName: 'Dijagram-Temperature',
    diagramId: 'temperature-diagram',
    disabled: true,
  },
  level: {
    id: 'level',
    tempLabel: "Mjerenje Nivoa",
    label: 'Dijagram Nivoa',
    unit: 'm',
    icon: WaterLevelIcon,
    color: '#6A4C93',
    lowAlarm: null,
    highAlarm: null,
    chartComponent: MonitoringChart,
    enumType: MeasurementType.Level,
    exportName: 'Dijagram-Nivoa',
    diagramId: 'level-diagram',
    disabled: true,
  },
  noise: {
    id: 'noise',
    tempLabel: "Mjerenje Šuma",
    label: 'Dijagram Šuma',
    unit: 'dB',
    icon: HearingIcon,
    color: '#E5007D',
    lowAlarm: null,
    highAlarm: null,
    chartComponent: MonitoringChart,
    enumType: MeasurementType.Noise,
    exportName: 'Dijagram-Šuma',
    diagramId: 'noise-diagram',
    disabled: true,
  },
  chlorine: {
    id: 'chlorine',
    tempLabel: "Mjerenje Hlora",
    label: 'Dijagram Hlora',
    unit: 'mg/L',
    icon: ScienceIcon,
    color: '#D97706',
    lowAlarm: null,
    highAlarm: null,
    chartComponent: MonitoringChart,
    enumType: MeasurementType.Chlorine,
    exportName: 'Dijagram-Hlora',
    diagramId: 'chlorine-diagram',
    disabled: false,
  },
  nightFlow: {
    id: 'nightFlow',
    label: 'Noćni minimum',
    unit: 'l/s',
    icon: NightsStayIcon,
    color: '#21538f',
    lowAlarm: null,
    highAlarm: null,
    chartComponent: lazyChart(() => import("../modal/NightFlowChart")),
    exportName: 'Nocni-minimum',
    diagramId: 'night-flow-diagram',
    periodLabel: `Zadnjih ${NIGHT_FLOW_DAYS} noći`,
    singleView: true,
    disabled: false,
  },
  cumulative: {
    id: 'cumulative',
    label: 'Akumulirani protok',
    unit: 'm³',
    icon: QueryStatsIcon,
    color: '#21538f',
    lowAlarm: null,
    highAlarm: null,
    chartComponent: lazyChart(() => import("../modal/CumulativeVolumeChart")),
    exportName: 'Akumulirani-protok',
    diagramId: 'cumulative-diagram',
    singleView: true,
    disabled: false,
  },
};
